import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router'
import MilkMoneyAccountingService, { ToursRowType } from '~/api/services/milkMoneyAccounting'
import Dialog from '~/components/Dialog'
import notify from '~/components/Notify'
import { handleErrors } from '~/utils/helpers'

interface Props {
  reloadTour: ToursRowType
  handleClose: () => void
  handleSubmit: () => void
}

const ReloadTourModal: React.FC<Props> = ({ reloadTour, handleClose, handleSubmit }) => {
  const { t } = useTranslation()
  const { id } = useParams()

  const [isBusy, setIsBusy] = useState(false)

  async function handleReloadTour() {
    setIsBusy(true)
    try {
      await MilkMoneyAccountingService.restoreMilkDeliveryTour(id, reloadTour?.id)
      notify(t('Succefully restored Tour [{{tourNumber}}]', { tourNumber: reloadTour?.tourNumber }), 'success')
      handleSubmit()
    } catch (error) {
      handleErrors(error)
    }
    setIsBusy(false)
  }

  return <Dialog
    isDialogOpen={Boolean(reloadTour)}
    textHeader={'Tour wiederherstellen'}
    textClose={t('Close')}
    textContent={`Möchten Sie die Tour [${reloadTour?.tourNumber}] wiederherstellen? Die darin enthaltenen Milchanlieferungen werden dann im Rahmen der Milchgeldabrechnung für die jeweiligen Landwirte wieder berücksichtigt.`}
    textSubmit={t('Delete Bank')}
    handleClose={() => handleClose()}
    isLoading={isBusy}
    handleSubmit={() => handleReloadTour()}
    type='abort'
  />
}
export default ReloadTourModal